import { ReactNode } from 'react';
import { LocalizedEnum } from '@mews/framework';
import { Container, Grid, Stack } from '@optimus-web/core';
import { Dash, LocalizedDateFromUtc } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { PaymentMethod, PaymentPlanDetailResult } from '@mews-commander/data-access';
import { PaymentPlanDetailItem } from '../../views/PaymentPlanDetails/PaymentPlanDetailItem';

const PaymentPlanDetailColumn = ({ children, leftPadding = false }: { children: ReactNode; leftPadding?: boolean }) => (
    <Container padding={['0', '0', '0', leftPadding ? '500' : '0']}>
        <Grid templateColumns="auto 1fr" columnGap="500" rowGap="200">
            {children}
        </Grid>
    </Container>
);

export const PaymentPlanDetailsDetailSection = ({ detail }: { detail: PaymentPlanDetailResult }) => (
    <Stack spacing="1200">
        <PaymentPlanDetailColumn>
            <PaymentPlanDetailItem description={TextKey.Space} value={detail.assignedSpace} />
            <PaymentPlanDetailItem description={TextKey.Service} value={detail.service} />
            <PaymentPlanDetailItem
                description={TextKey.BillingMode}
                value={<LocalizedEnum prefix="PaymentPlanBillingMode" value={detail.billingMode} />}
            />
            <PaymentPlanDetailItem description={TextKey.Rate} value={detail.rate ?? <Dash />} />
            {detail.paymentMethodData?.discriminator === PaymentMethod.SepaDirectDebit && (
                <PaymentPlanDetailItem
                    description={TextKey.PaymentPlanDetailMandateReference}
                    value={detail.paymentMethodData.value.mandateReference ?? <Dash />}
                />
            )}
        </PaymentPlanDetailColumn>
        <PaymentPlanDetailColumn leftPadding>
            <PaymentPlanDetailItem description={TextKey.Frequency} value={detail.frequency} />
            <PaymentPlanDetailItem
                description={TextKey.CreatedDate}
                value={<LocalizedDateFromUtc utcString={detail.createdDateUtc} />}
            />
            <PaymentPlanDetailItem
                description={TextKey.StartDate}
                value={<LocalizedDateFromUtc utcString={detail.startDateUtc} />}
            />
            <PaymentPlanDetailItem
                description={TextKey.EndDate}
                value={<LocalizedDateFromUtc utcString={detail.endDateUtc} />}
            />
        </PaymentPlanDetailColumn>
    </Stack>
);
